import { /* axios, */ AxiosResponse } from "axios";
import React, { Component } from "react";

import "./FileUploader.scss";

export interface FileUploaderProps {
    accept?: string;
    onDeleteFail: (file: File, reason: any) => void;
    onDeleteSuccess: (file: File, response?: AxiosResponse<any>) => void;
    onUploadFail: (file: File, reason: any) => void;
    onUploadProgress: (progress: number) => void;
    onUploadStart: (file: File) => void;
    onUploadSuccess: (file: File, response?: AxiosResponse<any>) => void;
    path: string;
}

interface FileUploaderState {
    loaded: number;
}

class FileUploader extends Component<FileUploaderProps, FileUploaderState> {
    public static defaultProps = {
        accept: "image/*",
    };

    public inputElement: HTMLInputElement | null;

    constructor(props: FileUploaderProps) {
        super(props);

        this.state = {
            loaded: 0,
        };
    }

    public render() {
        const { accept } = this.props;

        return (
            <input
                accept={accept}
                className="FileUploader"
                onChange={this.handleFileSelected}
                ref={(input) => (this.inputElement = input)}
                type="file"
            />
        );
    }

    public openUploadDialog = () => {
        if (this.inputElement) {
            this.inputElement.click();
        }
    };

    public deleteFile = (file: File) => {
        // TODO update delete API call when real API be ready
        const {
            // onDeleteFail,
            onDeleteSuccess,
            // path
        } = this.props;

        /* TODO remove the following code block when real API be ready,
            it's only purpose is to simulate downloading to test component's
            uploading behavior
        */
        let count = 0;
        const interval = setInterval(() => {
            if (count < 5) {
                count++;
            } else {
                clearInterval(interval);
                onDeleteSuccess(file);
            }
        }, 100);

        /* TODO uncomment the following code block when real API be ready
        axios
            .delete(path)
            .then(response => onDeleteSuccess(file, response))
            .catch(error => onDeleteFail(file, error)); */
    };

    public uploadFile = (file: File) => {
        // TODO update upload API call when real API be ready
        const {
            // onUploadFail,
            onUploadSuccess,
            onUploadStart,
            // path
        } = this.props;
        const data = new FormData();

        this.setState({ loaded: 0 }, () => {
            data.append("file", file, file.name);
            onUploadStart(file);

            /* TODO remove the following code block when real API be ready,
               it's only purpose is to simulate uploading to test component's
               uploading behavior
            */
            let count = 0;
            const interval = setInterval(() => {
                if (count < 100) {
                    count++;
                    this.handleUploadProgress({ loaded: count, total: 100 });
                } else {
                    clearInterval(interval);
                    onUploadSuccess(file);
                }
            }, 100);

            /* TODO uncomment the following code block when real API be ready
            // axios is needed here because we need to display upload progress percentage
            // and fetch doesn't provide progress information
            axios
                .post(path, data, {
                    onUploadProgress: this.handleUploadProgress
                })
                .then(response => onUploadSuccess(file, response))
                .catch(error => onUploadFail(file, error)); */
        });
    };

    private handleFileSelected = (event: any) => {
        const file = event.target.files[0];

        if (this.inputElement && this.inputElement.value) {
            this.uploadFile(file);
            this.inputElement.value = "";
        }
    };

    private handleUploadProgress = (progressEvent: any) => {
        this.setState(
            {
                loaded: (progressEvent.loaded / progressEvent.total) * 100,
            },
            () => this.props.onUploadProgress(this.state.loaded)
        );
    };
}

export default FileUploader;
